import React from "react";
import {
  BgColorsOutlined,
  BulbOutlined,
  CodeOutlined,
  TrophyOutlined,
} from "@ant-design/icons";
import { SKILL_AREAS, SkillArea } from "../firebase-chat";
import { getSkillDisplayName } from "./skillUtils";

export const SKILL_ICON_STYLE: Record<
  SkillArea,
  { color: string; icon: React.ReactNode }
> = {
  Programación: {
    color: "var(--dashboard-page-bg-alt)",
    icon: <CodeOutlined />,
  },
  Arte: { color: "var(--dashboard-teal)", icon: <BgColorsOutlined /> },
  Diseño: { color: "var(--dashboard-yellow-dark)", icon: <BulbOutlined /> },
};

const DEFAULT_SKILL_STYLE = {
  color: "var(--dashboard-track)",
  icon: <TrophyOutlined />,
};

export const getSkillIcon = (materia: string) => {
  const displayName = getSkillDisplayName(materia);
  return SKILL_AREAS.includes(displayName as SkillArea)
    ? SKILL_ICON_STYLE[displayName as SkillArea]
    : DEFAULT_SKILL_STYLE;
};
